import request from '@/utils/request';
// 登录
export function ForgetPwd(data) {
    return request({
        url: '/action/forgetPwd/index',
        method: 'POST',
        data
    });
}
